import { render, staticRenderFns } from "./ProfessionPageSectionLoading.vue?vue&type=template&id=dd24aebe"
import script from "./ProfessionPageSectionLoading.vue?vue&type=script&lang=js"
export * from "./ProfessionPageSectionLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports